var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintTransparent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 1024,
    viewBox: "0 0 1280 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 640 512)",
    id: "background-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    x: -640,
    y: -512,
    rx: 0,
    ry: 0,
    width: 1280,
    height: 1024
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 640 401.7806151101115)",
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30363453101740573 0 0 0.30363453101740573 0 2.842171e-14)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_20792",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 494.4001,
    y1: 793.48,
    x2: 494.4001,
    y2: 222.8311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,176,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(80,21,189)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_2_20792)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-494.4, -514.2)",
    d: "M 804.7 353.9 L 556.5 478.5 L 556.6 720.6 C 556.6 742.5 577.9 758 598.7 751.4 C 674.5 727.4 793.3000000000001 679.4 793.3000000000001 679.4 L 506.30000000000007 819.7 L 506.1000000000001 503.70000000000005 L 506.1000000000001 503.70000000000005 L 506.1000000000001 447.30000000000007 L 676.5000000000001 361.80000000000007 C 698.7000000000002 350.6000000000001 700.6000000000001 319.6000000000001 679.8000000000001 305.9000000000001 C 617.5000000000001 264.80000000000007 522.2 209.3000000000001 521.1000000000001 208.7000000000001 L 749.1000000000001 325.30000000000007 L 804.7 353.9 C 804.7 353.9 804.7 353.9 804.7 353.9 z M 184.1 353.9 L 184.1 639.7 C 184.1 639.7 193.7 492.90000000000003 208.7 412.40000000000003 C 212.6 391.3 235.79999999999998 379.8 255 389.50000000000006 L 482.7 503.80000000000007 L 482.7 447.4000000000001 L 184.1 297.6 L 184.1 353.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30363453101740573 0 0 0.30363453101740573 31.77535367097147 35.98069192556258)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_20793",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 499.5189,
    y1: 512.241,
    x2: 560.6752,
    y2: 669.9282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(102,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(43,92,219)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_3_20793)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-599.05, -632.6999999999999)",
    d: "M 600.3 756.2 C 626.1999999999999 748 657.1999999999999 737 686.9 726 L 511.4 811.8 L 511.2 503.79999999999995 C 511.2 503.69999999999993 511.2 503.59999999999997 511.2 503.49999999999994 L 511.2 453.59999999999997 L 551.6 479.99999999999994 L 551.7 720.6999999999999 C 551.7 741.3 568.4000000000001 757.9999999999999 589 757.9999999999999 C 592.7 758 596.6 757.4 600.3 756.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30363453101740573 0 0 0.30363453101740573 47.51880410422393 -42.42028478121853)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_20794",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 574.1462,
    y1: 366.424,
    x2: 670.0901,
    y2: 402.727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(102,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(43,92,219)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_4_20794)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-653.9999999999999, -376.1)",
    d: "M 699.3 335.2 C 700.0999999999999 321.7 693.8 309.3 682.5999999999999 301.8 C 671.0999999999999 294.2 658.3999999999999 286.1 645.3999999999999 278 L 793.6999999999998 353.9 L 554.3 474.1 C 554.1999999999999 474.1 554.1999999999999 474.20000000000005 554.0999999999999 474.20000000000005 L 514.3 449 L 678.8 366.4 C 690.8 360.3 698.5 348.7 699.3 335.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30363453101740573 0 0 0.30363453101740573 -48.88515949380235 -30.454543461045773)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_20795",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 374.4229,
    y1: 540.5403,
    x2: 297.6778,
    y2: 439.2127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(102,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(43,92,219)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_5_20795)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-333.4, -413.9)",
    d: "M 189.1 305.7 L 477.70000000000005 450.6 L 477.70000000000005 495.8 L 257.2 385.1 C 251.89999999999998 382.5 246.29999999999998 381.1 240.5 381.1 C 222.5 381.1 207.1 393.90000000000003 203.8 411.5 C 198 442.4 193 483.4 189.10000000000002 522.1 L 189.10000000000002 305.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30363453101740573 0 0 0.30363453101740573 -49.37612862170698 31.849160965808437)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_20796",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 338.9395,
    y1: 677.6793,
    x2: 322.1515,
    y2: 592.5401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(79,0,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(252,56,154)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_6_20796)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-331.78302604694017, -619.0930793842506)",
    d: "M 382.3 657.5 C 376.1 688.4 360.5 710.5 340.5 712 C 312.1 714.2 285.8 674 281.8 622.2 C 278.1 575.3000000000001 294 535 318 526.1 C 300.5 539.6 289.9 572.8000000000001 292.8 610.5 C 296.5 658.6 320.90000000000003 695.9 347.3 693.9 C 362.6 692.6 375.2 678.5 382.3 657.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30363453101740573 0 0 0.30363453101740573 -9.80739535186217 -64.52233784119875)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_20797",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 416.6617,
    y1: 285.9947,
    x2: 500.6017,
    y2: 321.969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(79,0,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(252,56,154)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_7_20797)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-462.1, -301.69999999999993)",
    d: "M 556.2 305.4 C 556.2 306.09999999999997 556.2 306.9 556.1 307.59999999999997 C 551.5 284.2 514.3000000000001 265.99999999999994 469.3 265.99999999999994 C 421.1 265.99999999999994 382 286.8999999999999 382 312.59999999999997 C 382 326.99999999999994 394.2 339.79999999999995 413.3 348.29999999999995 C 386.1 339.49999999999994 368 323.49999999999994 368 305.29999999999995 C 368 277.59999999999997 410.1 255.09999999999997 462.1 255.09999999999997 C 514 255.2 556.2 277.7 556.2 305.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30363453101740573 0 0 0.30363453101740573 62.493959452764784 16.244150094589685)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_20798",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 690.4382,
    y1: 655.2572,
    x2: 714.4211,
    y2: 499.3687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(79,0,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(252,56,154)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_8_20798)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-700.2196715747798, -567.6990208134742)",
    d: "M 740.8 568.8 C 739.6999999999999 620.8 715.6999999999999 662.4 687.3 661.8 C 677 661.5999999999999 667.5 655.8 659.5999999999999 646.0999999999999 C 663.9999999999999 648.8 668.8 650.1999999999999 673.8 650.3 C 700.1999999999999 650.9 722.5 612.1999999999999 723.5 564 C 724.5 517 705 478.3 679.5 475.8 C 683.3 474.3 687.3 473.5 691.3 473.6 C 719.8 474.2 741.9 516.8 740.8 568.8 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 639.8631177884616 681.906074014571)",
    id: "text-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "text-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-133.01, 19.95)",
    d: "M 10.49 -3.42 L 10.49 -14.82 L 19.61 -14.82 L 27.3 -22.52 L 27.3 -32.2 L 19.61 -39.9 L 2.85 -39.9 L 3.65 -36.48 L 3.65 -3.42 L 2.85 0 L 11.29 0 Z M 10.49 -21.66 L 10.49 -33.06 L 16.76 -33.06 L 20.46 -29.36 L 20.46 -25.37 L 16.76 -21.66 Z M 50.73 -3.42 L 50.73 -14.82 L 55.06 -14.82 L 60.19 -3.14 L 60.76 0 L 69.77 0 L 67.6 -3.14 L 61.67 -16.64 L 67.55 -22.52 L 67.55 -32.2 L 59.85 -39.9 L 43.09 -39.9 L 43.89 -36.48 L 43.89 -3.42 L 43.09 0 L 51.53 0 Z M 50.73 -21.66 L 50.73 -33.06 L 57 -33.06 L 60.71 -29.36 L 60.71 -25.37 L 57 -21.66 Z M 102.37 -10.54 L 98.67 -6.84 L 96.1 -6.84 L 92.4 -10.54 L 92.4 -29.36 L 96.1 -33.06 L 98.67 -33.06 L 102.37 -29.36 Z M 85.56 -7.7 L 93.25 0 L 101.52 0 L 109.21 -7.7 L 109.21 -32.2 L 101.52 -39.9 L 93.25 -39.9 L 85.56 -32.2 Z M 126.2 -21.09 L 124.2 -19.1 L 124.2 -17.39 L 126.2 -15.39 L 140.45 -15.39 L 142.44 -17.39 L 142.44 -19.1 L 140.45 -21.09 Z M 157.43 0 L 174.19 0 L 181.89 -7.7 L 181.89 -15.68 L 177.61 -19.95 L 181.89 -24.23 L 181.89 -32.2 L 174.19 -39.9 L 157.43 -39.9 L 158.23 -36.48 L 158.23 -3.42 Z M 165.07 -6.84 L 165.07 -16.53 L 171.34 -16.53 L 175.05 -12.83 L 175.05 -10.54 L 171.34 -6.84 Z M 165.07 -23.37 L 165.07 -33.06 L 171.34 -33.06 L 175.05 -29.36 L 175.05 -27.07 L 171.34 -23.37 Z M 197.68 0 L 206.11 0 L 205.31 -3.42 L 205.31 -11.34 L 215.29 -11.34 L 215.29 -3.42 L 214.49 0 L 222.93 0 L 222.13 -3.42 L 222.13 -32.2 L 214.43 -39.9 L 206.17 -39.9 L 198.47 -32.2 L 198.47 -3.42 Z M 205.31 -18.18 L 205.31 -29.36 L 209.02 -33.06 L 211.58 -33.06 L 215.29 -29.36 L 215.29 -18.18 Z M 238.72 0 L 255.47 0 L 263.17 -7.7 L 263.17 -15.68 L 258.89 -19.95 L 263.17 -24.23 L 263.17 -32.2 L 255.47 -39.9 L 238.72 -39.9 L 239.51 -36.48 L 239.51 -3.42 Z M 246.35 -6.84 L 246.35 -16.53 L 252.62 -16.53 L 256.33 -12.83 L 256.33 -10.54 L 252.62 -6.84 Z M 246.35 -23.37 L 246.35 -33.06 L 252.62 -33.06 L 256.33 -29.36 L 256.33 -27.07 L 252.62 -23.37 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 616.1623230769233 768.964390091494)",
    id: "tagline-6db81b10-6c07-4008-963a-f973567a2750-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.684342e-14 0)",
    id: "tagline-6db81b10-6c07-4008-963a-f973567a2750-logo-path-0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20799",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 1.3899999999999864 -16.5)",
    x1: -1.6335031471252819,
    y1: -12.511619999999994,
    x2: -1.6335031471252819,
    y2: 24.488380000000006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(48,35,174)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(200,109,215)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_20799)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-213.035, 8.25)",
    d: "M 1.39 -16.5 L 1.39 0 L 12.38 0 L 12.38 -6.86 L 10.99 -8.25 L 12.38 -9.64 L 12.38 -16.5 Z M 4.46 -13.76 L 9.31 -13.76 L 9.31 -9.64 L 4.46 -9.64 Z M 4.46 -6.86 L 9.31 -6.86 L 9.31 -2.74 L 4.46 -2.74 Z M 34.98 -16.5 L 34.98 0 L 38.05 0 L 38.05 -16.5 Z M 60.65 -16.5 L 60.65 -13.76 L 64.61 -13.76 L 64.61 0 L 67.68 0 L 67.68 -13.76 L 71.64 -13.76 L 71.64 -16.5 Z M 94.25 -16.5 L 94.25 0 L 105.24 0 L 105.24 -2.74 L 97.32 -2.74 L 97.32 -6.86 L 102.5 -6.86 L 102.5 -9.64 L 97.32 -9.64 L 97.32 -13.76 L 105.24 -13.76 L 105.24 -16.5 Z M 153.19 -16.5 L 153.19 0 L 156.26 0 L 156.26 -6.86 L 161.11 -6.86 L 161.11 0 L 164.18 0 L 164.18 -16.5 Z M 156.26 -13.76 L 161.11 -13.76 L 161.11 -9.64 L 156.26 -9.64 Z M 186.78 -16.5 L 186.78 0 L 189.85 0 L 189.85 -10.3 L 194.34 0 L 197.77 0 L 197.77 -16.5 L 194.7 -16.5 L 194.7 -6.2 L 190.21 -16.5 Z M 220.37 -16.5 L 220.37 0 L 229.28 0 L 231.36 -2.05 L 231.36 -14.45 L 229.28 -16.5 Z M 223.44 -13.76 L 228.29 -13.76 L 228.29 -2.74 L 223.44 -2.74 Z M 279.31 -16.5 L 279.31 -6.86 L 287.23 -6.86 L 287.23 -2.74 L 279.31 -2.74 L 279.31 0 L 290.3 0 L 290.3 -9.64 L 282.38 -9.64 L 282.38 -13.76 L 290.3 -13.76 L 290.3 -16.5 Z M 312.91 -16.5 L 312.91 0 L 315.97 0 L 315.97 -6.86 L 320.83 -6.86 L 320.83 0 L 323.89 0 L 323.89 -16.5 L 320.83 -16.5 L 320.83 -9.64 L 315.97 -9.64 L 315.97 -16.5 Z M 346.5 -16.5 L 346.5 0 L 349.57 0 L 349.57 -6.86 L 354.42 -6.86 L 354.42 0 L 357.49 0 L 357.49 -16.5 Z M 349.57 -13.76 L 354.42 -13.76 L 354.42 -9.64 L 349.57 -9.64 Z M 380.09 -16.5 L 380.09 0 L 383.16 0 L 383.16 -6.86 L 384.81 -6.86 L 387.85 0 L 391.08 0 L 388.05 -6.86 L 391.08 -6.86 L 391.08 -16.5 Z M 383.16 -13.76 L 388.01 -13.76 L 388.01 -9.64 L 383.16 -9.64 Z M 413.69 -16.5 L 413.69 0 L 424.68 0 L 424.68 -2.74 L 416.76 -2.74 L 416.76 -6.86 L 421.94 -6.86 L 421.94 -9.64 L 416.76 -9.64 L 416.76 -13.76 L 424.68 -13.76 L 424.68 -16.5 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintTransparent);
export default __webpack_public_path__ + "static/media/Print_Transparent.4acff741.svg";
export { ForwardRef as ReactComponent };